<template>
  <div class="cwkpPage" v-if="!showLoad">
    <div class="kpBox" v-if="kpPickerType">
      <h4 class="tit">开票</h4>
      <van-cell-group class="claimDetailBox">
        <div class="claimDetailLists">
          <div class="claimItem" v-for="(item,index) in InvoiceList" :key="index">
            <van-cell-group class="baseNone baseSalary">
              <van-field
                v-model="item.num"
                clearable
                type="number"
                v-enterIntNumber
                :readonly="!editType"
                :required="editType"
                :class="['ggInput',errorType == true ? 'errorStyle' : '']"
                input-align="right"
                @input="checkKpNumber"
                label="开票号："
                :placeholder="editType?'请输入...  ':''"
              />
            </van-cell-group>
            <van-cell-group class="baseNone baseSalary dwBox">
              <van-field
                v-model="item.numAmount"
                clearable
                type="number"
                v-enterIntNumber
                :readonly="!editType"
                :required="editType"
                class="ggInput"
                input-align="right"
                label="开票金额（元）："
                :placeholder="editType?'请输入...  ':''"
              />
            </van-cell-group>

            <div class="delect" v-if="InvoiceList.length>1 && editType">
              <van-icon name="cross" @click="delect(index)" />
            </div>
          </div>
        </div>
        <div class="addBtn" v-if="editType">
          <van-button
            icon="plus"
            type="primary"
            class="addClaim"
            size="small"
            @click="addClaim"
          >添加发票</van-button>
        </div>
      </van-cell-group>
    </div>
    <p class="fgx" v-if="kpDataList.length!=0"></p>
    <div class="applyList">
      <h4 class="tit" v-if="kpDataList.length!=0">开票申请</h4>
      <ul v-if="kpDataList.length!=0">
        <li v-for="item in kpDataList" :key="item.id">
          <div class="listMain">
            <p>
              申请人：
              <em>{{item.applicantIdName}}</em>
            </p>
            <p v-if="item.departmentName">
              申请部门：
              <em>{{item.departmentName}}</em>
            </p>
            <p class="clearfix">
              所属合同：
              <em>{{item.contractName}}</em>
            </p>
            <p>
              申请开票金额（元）：
              <em>{{item.amount}}</em>
            </p>
            <p class="clearfix">
              <span>
                发票类型：
                <em>{{item.typeName}}</em>
              </span>
            </p>
            <p v-if="item.oppositeTallage!=''">
              对方税号：
              <em>{{item.oppositeTallage}}</em>
            </p>
            <p>
              对方单位名称：
              <em>{{item.oppositeCompany}}</em>
            </p>
            <p>
              开票原因：
              <em>{{item.reason =='' ? '无':item.reason }}</em>
            </p>
          </div>
        </li>
      </ul>
    </div>
    <div v-if="editType">
      <div class="btnBox" v-if="!addKpBtnShow">
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
            >拒绝开票</van-button>
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="changeKpShowType"
            >同意开票</van-button>
          </van-col>
        </van-row>
      </div>
      <div class="btnBox addKp" v-if="addKpBtnShow">
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="cancelKp"
            >取消</van-button>
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkKpMoney"
            >保存</van-button>
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
import { getDeviceType, closePage } from "@/common/getDeviceType/getDeviceType";
import { dateFormat } from "@/utils/common";
export default {
  name: "cwkp",
  data() {
    return {
      commonId: "", //发票Id
      commonType: "",
      kpDataList: [],
      kpPickerType: false, //增加开票的表单
      addKpBtnShow: false, //是否显示保存按钮
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      editType: false,
      invoiceIds: [],
      InvoiceList: [
        //添加发票数组
        {
          num: "", //发票号
          numAmount: "" //开票金额
        }
      ],
      kpMoney: "", //总的开票金额
      fpMoney: "", //总的申请发票金额
      errorType: false,
      clientType: getDeviceType()
    };
  },
  mounted() {
    window.getKpIds = this.getKpIds;
    this.commonId = this.$route.query.commonId; //开票Id
    this.commonType = this.$route.query.commonType; //开票
    this.editType = this.commonType == "add" ? true : false;

    this.setShowLoad(false);
    this.initPage();
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    addClaim() {
      //添加报销明细函数
      this.InvoiceList.push({
        num: "", //发票号
        numAmount: "" //开票金额
      });
    },
    initPage() {
      if (this.clientType == "android") {
        window.android.getInfo(107);
      } else {
        window.webkit.messageHandlers.getKpIds.postMessage(null);
      }
       
    },
    getKpIds(data) {
      let ids = "";
        //  let ids = ["330"];
      if (this.clientType == "android") {
        ids = data;
      } else {
        ids = JSON.parse(data);
      }
      this.invoiceIds = ids;
      this.getListByInvoiceId(ids);
    },
    getListByInvoiceId(ids) {
      let _this = this;
      _this.$api.finance.invoice
        .getListByInvoiceId(ids)
        .then(res => {
          if (res.code == "1" && res.data != null) {
            _this.kpDataList = res.data;
            _this.fpMoney = parseFloat(_this.kpDataList[0].amount);
          }
        })
        .catch(err => {
          _this.$toast("网络失败，请稍后重试");
        });
    },

    delApply() {
      //拒绝开票
      let _this = this;
      _this.$dialog
        .confirm({
          title: "提示",
          message: "确认拒绝操作吗？"
        })
        .then(() => {
          this.btnLoading = true;
          _this.$api.finance.invoice
            .disagree(_this.invoiceIds)
            .then(res => {
              if (res.code == "1" && res.data != null) {
                let text = "操作成功";
                closePage(text);
              }
              this.btnLoading = false;
            })
            .catch(err => {
              _this.$toast("网络失败，请稍后重试");
              this.btnLoading = false;
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    //检测开票金额是否小于或等于申请发票金额
    checkKpMoney() {
      let _this = this;
      let status = "";
      _this.InvoiceList.forEach(item => {
        _this.kpMoney = parseFloat(_this.kpMoney + parseFloat(item.numAmount));
      });

      _this.InvoiceList.forEach((item1, index1) => {
        status = _this.InvoiceList.some(
          (item2, index2) => item1.num == item2.num && index1 !== index2
        );
      });
      if (status) {
        _this.$toast("发票号重复");
        _this.kpMoney = 0;
      } else {
        if (_this.fpMoney != _this.kpMoney) {
          _this.$toast("累计开票金额不等于发票金额");
          _this.kpMoney = 0;
        } else {
          _this.saveKp();
        }
      }
    },
    //检测发票号不能与之前的相同
    checkKpNumber(val) {
      let _this = this;
      let num = 0;
      _this.InvoiceList.forEach(item => {
        if (val == item.num) {
          num += 1;
        }
      });
      if (num > 2 || num == 2) {
        this.$toast("发票号重复");
      }
    },
    changeKpShowType() {
      //同意开票
      this.kpPickerType = true;
      this.addKpBtnShow = true;
    },
    //删除某一个开票信息
    delect(index) {
      this.InvoiceList.splice(index, 1);
    },
    cancelKp() {
      //取消开票
      this.kpPickerType = false;
      this.addKpBtnShow = false;
    },
    saveKp() {
      //保存开票
      let _this = this;
      _this.btnLoading = true;
      _this.$api.finance.invoice
        .makeInvoice({
          invoiceId: _this.invoiceIds,
          makeInvoiceList: _this.InvoiceList
        })
        .then(res => {
          if (res.code == "1" && res.data != null) {
            let text = "保存成功";
            closePage(text);
          }
          _this.btnLoading = false;
        })
        .catch(err => {
          _this.$toast("网络失败，请稍后重试");
          _this.btnLoading = false;
        });
    }
  },
  computed: {
    ...mapState(["showLoad", "userinfo"])
  }
};
</script>
<style lang="less">
.cwkpPage {
  width: 100%;
  min-height: 100%;
  background-color: #fff;
  .fgx {
    width: 100%;
    height: 8px;
    background-color: #f6f6f6;
  }
  h4.tit {
    position: relative;
    border-bottom: 1px solid #e0e0e0;
    line-height: 25px;
    padding: 0 25px;
    padding-right: 0;
    padding-bottom: 5px;
    font-weight: 700;
    color: #2581d6;
    font-size: 15px;
    z-index: 10;
    background-color: #fff;
  }
  h4.tit:before {
    content: "";
    position: absolute;
    width: 5px;
    background: #2581d6;
    top: 0;
    left: 15px;
    bottom: 5px;
  }

  //添加开票
  .claimDetailBox {
    width: 100%;
    padding-bottom: 10px;
    .claimDetailLists {
      width: 95%;
      margin: 0 auto;
      min-height: 140px;
    }
    .addBtn {
      margin-top: 10px;
      width: 100%;
      .addClaim {
        display: block;
        margin: 0 auto;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
      }
    }
  }
  .claimItem {
    margin-top: 10px;
    border: 1px solid #f1f1f1;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    position: relative;
    .delect {
      text-align: center;
      position: absolute;
      top: -6px;
      right: -4px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      border-radius: 50%;
      background: #fff;
      border: 1px solid red;
      color: red;
      cursor: pointer;
      padding-top: 1px;
    }
  }
  .baseNone.dwBox {
    .van-cell {
      .van-cell__title {
        width: 160px;
      }
    }
  }
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #666;
      }
    }
    .van-cell__value {
      position: relative;
      .van-field__error-message {
        position: absolute;
        right: 0;
        top: 20;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .baseNone {
    .van-cell.errorStyle {
      min-height: 60px;
    }
  }

  .applyList {
    padding-top: 10px;
    padding-bottom: 75px;
    li {
      width: 100%;
      margin: 10px 0;
      padding: 0 16px 8px 16px;
      border-bottom: 1px solid #f6f6f6;
      .listMain {
        p {
          font-size: 14px;
          color: #333;
          margin: 5px 0;
          border-bottom: 1px solid #f6f6f6;
          padding: 7px 10px 7px 0;
          em {
            float: right;
            color: #666;
            font-weight: normal;
          }
        }
      }
    }
    li:last-child {
      border: 0 none;
    }
  }
  .btnBox {
    // background-color: #fff;
    background-color: #fff;
    padding-top: 10px;
    z-index: 999;
    height: 65px;
    bottom: 0;
    .van-col {
      position: relative;
      height: 45px;
      button {
        width: 120px;
        margin: 0 auto;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
        position: absolute;
        left: 50%;
        margin-left: -60px;
        span {
          line-height: 45px;
        }
      }
    }
  }
}
</style>